<div class="card cliente-analise-mercado-perspectiva-projetada-list"
     [class.referencia-atual]="isMesAtual"
     [class.perspectiva-meta]="isPerspectivaMeta">
    <div class="card-header">
        <ng-template [ngIf]="isSaving">
            <i class="fas fa-sync fa-spin"></i> Salvando...
        </ng-template>

        <ng-template [ngIf]="isSaved">
            <i class="fas fa-check"></i> Alterações salvas
        </ng-template>
    </div>
    <div class="card-table">
        <table class="table table-striped table-hover table-bordered" [id]="idDataTable">
            <thead>
                <tr>
                    <th class="col-options text-center row-span-2" rowspan="2"></th>
                    <!-- <th class="col-status row-span-2" rowspan="2" style="padding-right: 3px !important;">Status</th> -->
                    <th class="col-nome-cliente row-span-2" rowspan="2">Cliente</th>
                    <th class="col-nome-representante row-span-2" rowspan="2">Representante</th>
                    <th class="col-classificacoes-nome row-span-2" rowspan="2">Segmento</th>
                    <!-- <th class="col-casdastro-situacao text-center row-span-2" rowspan="2">Cadastro/Situação</th> -->
                    <!-- <th class="col-nome-cliente-tipo row-span-2" rowspan="2">Tipo</th> -->
                    <!-- <th class="col-nome-item-tipo row-span-2" rowspan="2">Tipo de Produto</th> -->
                    <th colspan="4" class="col-quantidade text-center">Quantidade</th>
                    <th colspan="4" class="col-peso text-center">Peso</th>
                    <th colspan="3" class="col-valor text-center">Valor</th>
                </tr>
                <tr>
                    <!-- Quantidade -->
                    <th class="col-quantidade col-quantidade-pretendida text-right" title="Quantidade Pretendida">Pretendida</th>
                    <th class="col-quantidade col-quantidade-projetada-valor-unitario text-right" title="Preço Médio">Preço Médio</th>
                    <th class="col-quantidade col-quantidade-projetada text-right" title="Quantidade Projetada">Projetada</th>
                    <th class="col-quantidade col-quantidade-realizada text-right" title="Quantidade Realizada">Realizada</th>

                    <!-- Peso -->
                    <th class="col-peso col-peso-pretendido text-right" title="Peso Pretendido">Pretendido</th>
                    <th class="col-peso col-peso-projetado-valor-unitario text-right" title="Preço Médio">Preço Médio</th>
                    <th class="col-peso col-peso-projetado text-right" title="Peso Projetado">Projetado</th>
                    <th class="col-peso col-peso-realizado text-right" title="Peso Realizado">Realizado</th>

                    <!-- Valor -->
                    <th class="col-valor col-valor-pretendido text-right" title="Valor Pretendido">Pretendido</th>
                    <th class="col-valor col-valor-projetado text-right" title="Valor Projetado">Projetado</th>
                    <th class="col-valor col-valor-realizado text-right" title="Valor Realizada">Realizado</th>
                </tr>
            </thead>
            <tfoot>
                <tr>
                    <td colspan="4" class="text-center">
                        {{total?.quantidadeClientes | decimalFormat: 1:0:0}} cliente(s)
                    </td>

                    <!-- Quantidade -->
                    <td class="col-quantidade col-quantidade-pretendida text-right">
                        {{total?.quantidadePretendida | decimalFormat: 1:0:0}}
                    </td>
                    <td class="col-quantidade col-quantidade-projetada-valor-unitario text-right"></td>                     
                    <td class="col-quantidade col-quantidade-projetada text-right">
                        {{total?.quantidadeProjetada | decimalFormat: 1:0:0}}

                        <!-- <sgt-table-perc-progress
                            [perc]="total?.quantidadeProjetadaPerc">
                        </sgt-table-perc-progress> -->
                    </td>
                    <td class="col-quantidade col-quantidade-realizada text-right">
                        {{total?.quantidadeRealizada | decimalFormat: 1:0:0}}

                        <!-- <sgt-table-perc-progress
                            [perc]="total?.quantidadeRealizadaPercProjetada">
                        </sgt-table-perc-progress>                        -->
                    </td>
                    
                    <!-- Peso -->
                    <td class="col-peso col-peso-pretendido text-right">
                        {{total?.pesoPretendido | decimalFormat: 1:0:0}}
                    </td>
                    <td class="col-peso col-peso-projetado-valor-unitario text-right"></td>                     
                    <td class="col-peso col-peso-projetado text-right">
                        {{total?.pesoProjetado | decimalFormat: 1:0:0}}

                        <!-- <sgt-table-perc-progress
                            [perc]="total?.pesoProjetadoPerc">
                        </sgt-table-perc-progress> -->
                    </td>
                    <td class="col-peso col-peso-realizado text-right">
                        {{total?.pesoRealizado | decimalFormat: 1:0:0}}

                        <!-- <sgt-table-perc-progress
                            [perc]="total?.pesoRealizadoPercProjetado">
                        </sgt-table-perc-progress>                        -->
                    </td>

                    <!-- Valor -->              
                    <td class="col-valor col-valor-pretendido text-right">
                        {{total?.valorPretendido | decimalFormat: 1:0:0}}
                    </td>    
              
                    <td class="col-valor col-valor-projetado text-right">
                        {{total?.valorProjetado | decimalFormat: 1:0:0}}

                        <!-- <sgt-table-perc-progress
                            [perc]="total?.valorProjetadoPerc">
                        </sgt-table-perc-progress> -->
                    </td>
                    <td class="col-valor col-valor-realizado text-right">
                        {{total?.valorRealizado | decimalFormat: 1:0:0}}

                        <!-- <sgt-table-perc-progress
                            [perc]="total?.valorRealizadoPercProjetado">
                        </sgt-table-perc-progress>                        -->
                    </td> 
                </tr>
                <!-- Totais da meta -->
                <tr class="meta-totais" *ngIf="isPerspectivaMeta">
                    <td colspan="4" class="text-center">
                        Meta
                    </td>

                    <!-- Quantidade -->
                    <td class="col-quantidade col-quantidade-pretendida text-right"></td>
                    <td class="col-quantidade col-quantidade-projetada-valor-unitario text-right"></td>                     
                    <td class="col-quantidade col-quantidade-projetada text-right">
                        {{metaTotais?.quantidadeRepresentantes | decimalFormat: 1:0:0}}
                    </td>
                    <td class="col-quantidade col-quantidade-realizada text-right">
                        <sgt-meta-indicador-realizado-perc-progress
                            [perc]="quantidadeMetaRepresentantesPercProjetada">
                        </sgt-meta-indicador-realizado-perc-progress>
                    </td>
                    
                    <!-- Peso -->
                    <td class="col-peso col-peso-pretendido text-right"></td>
                    <td class="col-peso col-peso-projetado-valor-unitario text-right"></td>                    
                    <td class="col-peso col-peso-projetado text-right">
                        {{metaTotais?.pesoRepresentantes | decimalFormat: 1:0:0}}
                    </td>
                    <td class="col-peso col-peso-realizado text-right">
                        <sgt-meta-indicador-realizado-perc-progress
                            [perc]="pesoMetaRepresentantesPercProjetado">
                        </sgt-meta-indicador-realizado-perc-progress>                        
                    </td>

                    <!-- Valor -->
                    <td class="col-valor col-valor-pretendido text-right"></td> 
                    <td class="col-valor col-valor-projetado text-right">
                        {{metaTotais?.valorRepresentantes | decimalFormat: 1:0:0}}
                    </td>    
              
                    <td class="col-valor col-valor-realizado text-right">
                        <sgt-meta-indicador-realizado-perc-progress
                            [perc]="valorMetaRepresentantesPercProjetado">
                        </sgt-meta-indicador-realizado-perc-progress>                        
                    </td>
                </tr>
            </tfoot>
        </table>         
    </div>
</div>


<!-- Form Lançamento Modal -->
<sgt-cliente-analise-mercado-lancamento-form-modal
    #lancamentoFormModal
    (afterSave)="afterSaveLancamentoClassificacao()">
</sgt-cliente-analise-mercado-lancamento-form-modal>

<!-- Cliente Form Modal -->
<sgt-cliente-form-modal
    #clienteFormModal
    (afterEdit)="afterEditCliente()">
</sgt-cliente-form-modal>

<!-- Modal para atualiar uma central de compras-->
<sgt-cliente-central-compra-form-modal
    #centralCompraFormModal
    (afterSave)="afterSaveCentralCompra()">
</sgt-cliente-central-compra-form-modal>

<!-- Modal para adicionar um participante em uma central de compras -->
<sgt-cliente-central-compra-participante-form-insert-modal
    #centralCompraParticipanteFormModal
    (afterSave)="afterSaveCentralCompra()">
</sgt-cliente-central-compra-participante-form-insert-modal>

<!-- Modal para pré-baixar um cliente -->
<sgt-cliente-carteira-prebaixar-modal
    #clienteCarteiraPreBaixarModal
    [isRepresentante]="isRepresentante"
    (afterInsertPreBaixa)="refresh()"
    (afterEditPreBaixa)="refresh()">
</sgt-cliente-carteira-prebaixar-modal>

<!-- Modal para baixar um cliente -->
<sgt-cliente-carteira-baixar-modal
    #clienteCarteiraBaixarModal
    [isRepresentante]="isRepresentante"
    (afterInsertBaixa)="refresh()"
    (afterEditBaixa)="refresh()">
</sgt-cliente-carteira-baixar-modal>

<!-- Container para criar dinamicamente o badge pill do status projetado -->
<ng-template #statusProjetadoBadgePillContainer></ng-template>

<!-- Container para criar dinamicamente os progress dos percentuais na table -->
<ng-template #tablePercProgressContainer></ng-template>